var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"term"},[_c('div',{staticClass:"termlist"},[_c('term-new',{attrs:{"list":_vm.applylist}})],1),_c('form-data',{attrs:{"list":_vm.formlist,"isterm":_vm.isterm},on:{"getAuth":_vm.getAuth,"goterm":_vm.goterm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }